import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { numberWithCommas } from "../../assets/js/utils";

const useCounterAnimation = (
  counterRef,
  value,
  isVisible,
  animationClassNames = "waviy"
) => {
  // const counterRef = useRef();
  const generalSettings = useSelector((state) => state.ui.generalSettings);
  useEffect(() => {
    if (counterRef.current && isVisible) {
      const number = numberWithCommas(value);
      let result = "";
      if (generalSettings.rtlLanguage) {
        for (let i = number.length - 1; i >= 0; i--) {
          result += `<span style="--i:${i + 1}">${number[i]}</span>`;
        }
      } else {
        for (let i = 0; i < number.length; i++) {
          result += `<span style="--i:${i + 1}">${number[i]}</span>`;
        }
      }

      counterRef.current.innerHTML = `<span class="${animationClassNames}">${result}</span>`;
    }
  });

  return counterRef;
};

export default useCounterAnimation;
